export { NebulyPageCard as AiProficiencyReportCard } from '@/domains/pages/shared/nebuly-page-card';
